<template>
  <div>
    <div class="w10 f_r" @click="showFilter(false)">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon_close">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
    <div class="box_flex main_search">
      <div class="w85">
        <input placeholder="수신인, 운송장 번호를 검색하세요" v-model="filterData.textData" class="">
      </div>
      <div class="w15 txt_c">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon_search">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
        </svg>
      </div>
    </div>
    <div>
      <dl class="box_input w100">
        <dt>기간</dt>
        <dd>
          <div class="box_flex w100">
            <kendo-datepicker
                ref="frstRgstDtStartDtRef"
                :placeholder="'년/월/일'"
                :format="'yyyy/MM/dd'"
                :min="minDt"
                :max="maxDt"
                v-model="filterData.frstRgstDtStartDt"
                @change="filterData.frstRgstDtRange = null"
            >
            </kendo-datepicker>
            <span class="txt_c w15">-</span>
            <kendo-datepicker
                ref="frstRgstDtEndDtRef"
                :placeholder="'년/월/일'"
                :format="'yyyy/MM/dd'"
                :min="minDt"
                :max="maxDt"
                v-model="filterData.frstRgstDtEndDt"
            >
            </kendo-datepicker>
          </div>
          <div class="box_flex w100 mgt10">
            <div v-for="item in [{cdId: '1w', cdNm: '1주일'}, {cdId: '1m', cdNm: '1개월'}, {cdId: '3m', cdNm: '3개월'}, {cdId: '12m', cdNm: '12개월'}]"
                 :class="{rbtn: 'rbtn', on: item.cdId === filterData.frstRgstDtRange}"
                 @click="onChangeRange(item.cdId)">
              {{ item.cdNm }}
            </div>
          </div>
        </dd>
        <dt>
          대리수령
        </dt>
        <dd>
          <div class="box_tab">
            <div v-for="item in steadYnList"
                 :class="{w30: 'w30', on: item.cdId === filterData.steadYn}"
                 @click="filterData.steadYn = item.cdId">
              {{ item.cdNm }}
            </div>
          </div>
        </dd>
        <dt>발송</dt>
        <dd>
          <div class="box_tab">
            <div v-for="item of sendScnList"
                 :class="{w25: 'w25', on: item.cdId === filterData.sendScn}"
                 @click="filterData.sendScn = item.cdId"
            >
              {{ item.cdNm }}
            </div>
          </div>
        </dd>
      </dl>
      <div class="box_btn">
        <div class="w20 mid_btn txt_c" @click="showFilter(false)">닫기</div>
        <div class="w80 mid_btn gra  txt_c" @click="setFilter">확인</div>
      </div>
    </div>
  </div>
</template>

<script>
import {LogisticsCodeDtlMixin} from "@/mixin/Mixin";
export default {
  name: "ReserveListFilter",
  mixins: [LogisticsCodeDtlMixin],
  props: {
    oldFilterData : {
      type : Object,
      required : true,
      default : function (){
        return {}
      }
    },
  },
  methods: {
    showFilter (isShowFilter) {
      const vm = this
      // 초기화
      vm.filterData = {...vm.oldFilterData}
      vm.$emit('showFilter', isShowFilter)
    },

    setFilter () {
      const vm = this
      vm.$emit('setFilter', vm.filterData)
    },

    onChangeRange (cdId) {
      const vm = this
      vm.filterData.frstRgstDtRange = cdId

      // startDt 세팅
      const endDt = vm.filterData.frstRgstDtEndDt
      const type = cdId[cdId.length-1]
      const amount = cdId.replace(type, "")
      if(type === 'w') {
        vm.filterData.frstRgstDtStartDt = new Date(new Date().setDate(endDt.getDate() - amount*7))
      }else if (type === 'm') {
        vm.filterData.frstRgstDtStartDt = new Date(new Date().setMonth(endDt.getMonth() - amount))
      }
    }
  },
  data () {
    const now = new Date()

    return {
      steadYnList: [{cdId: '', cdNm: '전체'}, {cdId: 'N', cdNm: '본인'}, {cdId: 'Y', cdNm: '대리'}],
      minDt: new Date(now.setFullYear(now.getFullYear() - 1)),
      maxDt: new Date(),
      filterData: {...this.oldFilterData}
    }
  }
}
</script>

<style scoped>

</style>